var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUserIcon = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15.5 8a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0M17 8A5 5 0 1 1 7 8a5 5 0 0 1 10 0m-5 5c-4.46 0-8.161 3.243-8.876 7.5A9.06 9.06 0 0 0 3 22h18c0-.511-.043-1.012-.124-1.5C20.16 16.243 16.459 13 12 13m-7.35 7.5a7.503 7.503 0 0 1 14.7 0z",
    clipRule: "evenodd"
  })));
};
export default SvgUserIcon;